import { render, staticRenderFns } from "./ModalPaymentInfo.vue?vue&type=template&id=2429b934&"
import script from "./ModalPaymentInfo.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalPaymentInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
